module.exports = __webpack_public_path__ + "img/img／1 (1).56c98b8a.png";